import { render, staticRenderFns } from "./VehicleActions.vue?vue&type=template&id=10ff15fe&lang=pug&"
import script from "./VehicleActions.vue?vue&type=script&lang=ts&"
export * from "./VehicleActions.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleActions.vue?vue&type=style&index=0&id=10ff15fe&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports